import { render, staticRenderFns } from "./OrderAsideNew.vue?vue&type=template&id=362f7a2a&scoped=true&"
import script from "./OrderAsideNew.vue?vue&type=script&lang=js&"
export * from "./OrderAsideNew.vue?vue&type=script&lang=js&"
import style0 from "./OrderAsideNew.vue?vue&type=style&index=0&id=362f7a2a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "362f7a2a",
  null
  
)

export default component.exports